export enum FILTERS {
  RECOMMENDED = 'recomendado',
  ACCOMMODATION_TYPE = 'tipo de alojamiento',
  MEAL = 'plan de comida',
  PAYMENT_METHOD = 'metodo de pago',
  STAR = 'estrellas',
  AMENITY = 'servicios',
  DISCOUNTS = 'descuentos',
  RATING = 'puntuacion',
  PRICE_RANGE = 'precio',
}
